import classnames from 'classnames'
import { __ } from '@wordpress/i18n'
import { compose } from '@wordpress/compose'
import {
	addFilter,
	applyFilters
} from '@wordpress/hooks'
import {
	RichText
} from '@wordpress/block-editor'
import {
	PanelBody,
	RangeControl,
	ToggleControl,
	SelectControl,
	BaseControl,
	Disabled,
} from '@wordpress/components'
import {
	Fragment,
	useRef,
	useEffect
} from '@wordpress/element'
import {
	DesignPanelBody,
	UserSelector,
	ResponsiveControl,
	AdvancedRangeControl,
} from '~cartzillagb/components'
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import {
	getAttrName,
} from '~cartzillagb/util'
import PanelImage  from  './images/panel-image.png'
import { i18n } from 'cartzillagb'

import Block from './block'

import $ from 'jquery'

import './common'

addFilter( 'cartzillagb.seller-block.edit.inspector.layout.before', 'cartzillagb/seller-block', ( output, props ) => {
	const {
		attributes,
		setAttributes
	} = props

	const {
		design,
	} = attributes

	return (
		<DesignPanelBody
			title={ __( 'Product Style', i18n ) }
			initialOpen={ true }
			selected={ design }
			options={ applyFilters( 'cartzillagb.seller-block.edit.inspector.design', [
				{
					label: __( 'WooCommerce', i18n ), value: 'style-v1', image: PanelImage,
				},
				{
					label: __( 'Market Place', i18n ), value: 'style-v2', image: PanelImage,
				},
				{
					label: __( 'Grocery', i18n ), value: 'style-v3', image: PanelImage,
				},
			] ) }
			onChange={ design => {
				setAttributes( { design } )
			} }
		/>
	)
} )

addFilter( 'cartzillagb.seller-block.edit.inspector.style.before', 'cartzillagb/seller-block', ( output, props ) => {
	const {
		attributes,
		setAttributes,
	} = props

	const {
		enableContainer,
		users,
		limit,
		orderby,
		order,
		dots,
		// arrows,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<BaseControl label={ __( 'Select Users', i18n ) } id={ "users" }>
					<UserSelector
						onUserSelect={ user => {
							users.push(user)
							setAttributes({ users: [...users] })
						} }
						users={ users }
						onChange={ newValue => {
							setAttributes({ users: [...newValue] })
						} }
						limit={ 1 }
						roles={ 'administrator, seller' }
					/>
				</BaseControl>
				{ users.length > 0 && (
					<Fragment>
						<RangeControl
							label={ __( 'Limit', i18n ) }
							value={ limit }
							onChange={ limit => setAttributes( { limit } ) }
							min={ 1 }
							max={ applyFilters( 'cartzillagb.seller-block.edit.inspector.max.limit', 30 ) }
						/>
						<SelectControl
							label={ __( 'Orderby', i18n ) }
							value={ orderby }
							options={ [
								{ value: 'date', label: __( 'Date', i18n ) },
								{ value: 'id', label: __( 'ID', i18n ) },
								{ value: 'menu_order', label: __( 'Menu Order', i18n ) },
								{ value: 'rand', label: __( 'Random', i18n ) },
								{ value: 'title', label: __( 'Title', i18n ) },
							] }
							onChange={ orderby => setAttributes( { orderby } ) }
						/>
						<SelectControl
							label={ __( 'Order', i18n ) }
							value={ order }
							options={ [
								{ value: 'ASC', label: __( 'ASC', i18n ) },
								{ value: 'DESC', label: __( 'DESC', i18n ) },
							] }
							onChange={ order => setAttributes( { order } ) }
						/>
					</Fragment>
				) }
			</PanelBody>
			{ users.length > 0 && (
				<PanelBody title={ __( "Carousel Options", i18n ) } initialOpen={ true }>
					<ResponsiveControl
						attrNameTemplate="slidesToShow%s"
						setAttributes={ setAttributes }
						blockAttributes={ attributes }
						screens={ [ 'desktop', 'laptop', 'tablet', 'mobile' ] }
					>
						<AdvancedRangeControl
							label={ __( 'Slides To Show', i18n ) }
							min={ 1 }
							max={ applyFilters( 'cartzillagb.seller-block.edit.inspector.max.slidesToShow', 4 ) }

						/>
					</ResponsiveControl>
					<ToggleControl
						label={ __( 'Enable Dots', i18n ) }
						checked={ dots }
						onChange={ dots => setAttributes( { dots } ) }
					/>
					{ /*<ToggleControl
						label={ __( 'Enable Arrow', i18n ) }
						checked={ arrows }
						onChange={ arrows => setAttributes( { arrows } ) }
					/>*/ }
				</PanelBody>
			) }
		</Fragment>
	)
} )

const edit = props => {
	const {
		clientId,
		className,
		attributes,
		setAttributes,
	} = props

	const {
		blockId,
		enableContainer,
		title,
		users,
		slidesToShow,
		slidesToShowLaptop,
		slidesToShowTablet,
		slidesToShowMobile,
		dots,
		arrows,
	} = attributes

	const titleComp = (
		<RichText
			tagName='h2'
			value={ title || __( "Seller of the month", i18n ) }
			className="h3 mb-3 pb-3 pb-lg-4 text-center"
			onChange={ title => setAttributes( { title } ) }
			placeholder={ __( 'title' ) }
			keepPlaceholderOnFocus
		/>
	)

	if( users.length < 1 ) {
		return (
			<div id={ blockId || clientId } className={ 'components-placeholder' }>
				<BaseControl label={ __( 'Select Users', i18n ) } id={ "user" } className="components-placeholder__label czgb-cartzillagb-icon-gradient text-primary">
					<UserSelector
						onUserSelect={ user => {
							users.push(user)
							setAttributes({ users: [...users] })
						} }
						users={ users }
						onChange={ newValue => {
							setAttributes({ users: [...newValue] })
						} }
						limit={ 1 }
						roles={ 'administrator, seller' }
					/>
				</BaseControl>
			</div>
		)
	}

	const setBlockId = blockId => setAttributes({ blockId })

	if ( clientId !== blockId ) {
		setBlockId( clientId )
	}

	const slickEl = useRef( blockId || clientId )

	const getAttrValue = ( attrName, defaultValue = '' ) => {
		const value = attributes[ getAttrName( attrName ) ]
		return value === 0 ? value : ( value || defaultValue )
	}

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-seller-block' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		enableContainer
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-seller-block' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'dots': attributes.dots,
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'updateDots' )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		dots
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-seller-block' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'arrows': attributes.arrows,
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'updateArrows' )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		arrows
	] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.products' ).length && $( slickEl.current ).closest( '.wp-block-czgb-seller-block' ).data( 'slick-attributes' ) ) {
			if( $( slickEl.current ).find( '.products.slick-initialized' ).length ) {
				let slickAttributes = JSON.parse( $( slickEl.current ).attr( 'data-slick-attributes' ) )
				const slickId = $( slickEl.current ).attr( 'id' )

				if( slickAttributes && slickAttributes.customArrows && ! slickAttributes.appendArrows ) {
					slickAttributes = { ...slickAttributes, appendArrows: `#${slickId} ${slickAttributes.customArrows}` }
				}

				$( slickEl.current ).find( '.products' ).attr( 'data-slick', JSON.stringify( {...slickAttributes} ) )
				$( slickEl.current ).find( '.products' ).slick( 'setOption', {
					'slidesToShow': attributes.slidesToShow,
					'responsive': [
						{
							breakpoint: 1199.98,
							settings: {
								slidesToShow: slidesToShowLaptop,
							}
						},
						{
							breakpoint: 991.98,
							settings: {
								slidesToShow: slidesToShowTablet,
							}
						},
						{
							breakpoint: 575.98,
							settings: {
								slidesToShow: slidesToShowMobile,
							}
						}
					],
				}, true )
				$( slickEl.current ).find( '.products' ).slick( 'updateDots' )
				$( slickEl.current ).find( '.products' ).slick( 'updateArrows' )
				$( slickEl.current ).find( '.products' ).slick( 'refresh' )
			}
		}
	}, [
		slidesToShow,
		slidesToShowLaptop,
		slidesToShowTablet,
		slidesToShowMobile,
	] )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.seller-block.main-block.classes', {
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		adaptiveHeight: true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		customArrows: '.cz-custom-controls',
		speed: 500,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: 1,
				}
			}
		],
	}, props )

	let carouselOptions = {
		slidesToShow: getAttrValue( 'slidesToShow', 3 ),
		dots: getAttrValue( 'dots' ),
		arrows: getAttrValue( 'arrows' ),
		responsive: [
			{
				breakpoint: 1198.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowLaptop', 3 ),
				}
			},
			{
				breakpoint: 991.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowTablet', 3 ),
				}
			},
			{
				breakpoint: 575.98,
				settings: {
					slidesToShow: getAttrValue( 'slidesToShowMobile', 1 ),
				}
			}
		],
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	return (
		<section
			ref={ slickEl }
			id={ blockId || clientId }
			className={ classnames( [
				className,
				'wp-block-czgb-seller-block',
				'py-5',
			], {} ) }
			data-slick-classes="js-slick-carousel"
			data-slick-attributes={ JSON.stringify( carouselOptions ) }
		>
			<div
				className={  classnames( [
					'py-lg-2',
					enableContainer ? 'container' : '',
				], {} ) }
			>
				{ titleComp }
				<div className="ajax-content">
					<Disabled>
						<Block attributes={ { ...attributes } } />
					</Disabled>
				</div>
			</div>
		</section>
	)
}

export default compose(
	withTabbedInspector( [ 'layout', 'style', 'advanced' ] ),
)( edit )